export const isFunction = (functionToCheck) =>
  functionToCheck && {}.toString.call(functionToCheck) === "[object Function]";

export const isObject = (object) => object && typeof object === "object";
export const isString = (str) => str && typeof str === "string";
export const isBoolean = (bool) => bool && typeof bool === "boolean";
